import {
  stepTripInterruptionTugoLookup,
  stepTripCancellationTugoLookup,
  stepTripCancellationTravellerTugoLookup,
} from './claimCodeMapper';

function mapToParentSection() {
  return {};
}

function mapToQuestionnaire() {
  return [];
}

function getClaimCodeFromLookup(lookupKey) {
  const lookup = stepTripInterruptionTugoLookup[lookupKey];
  return lookup && lookup.associatedClaimCodes && lookup.associatedClaimCodes.length > 0
    ? lookup.associatedClaimCodes[0]
    : (lookup && lookup.claimCode) || null;
}

function mapHealthExpenseItem(item, claimCode) {
  if (!item) return null;
  const amount = item.amountClaimed;
  if (amount !== 0 && (amount === undefined || amount === '')) return null;
  const currency = item.amountClaimedCurrency || item.currency || '';
  const selectedClaimForArray = item.selectedClaimFor
    ? (!Array.isArray(item.selectedClaimFor) ? item.selectedClaimFor.toJS() : item.selectedClaimFor)
    : [];
  const claimForInsuredIds = selectedClaimForArray.map((c) => c.policyRoleID);
  const desc = item.descriptionOfExpense || 'Expense';
  return {
    shortDescription: desc,
    dateOfExpense: item.dateOfExpense || '',
    clientCost: amount,
    currency,
    rate: null,
    requestedAmount: null,
    claimTypeCode: claimCode,
    ...(claimForInsuredIds.length ? { claimForInsuredIds, claimForInsureds: selectedClaimForArray } : {}),
  };
}

function mapHealthExpensesByType(data, itemsKey, lookupKey) {
  const claimCode = getClaimCodeFromLookup(lookupKey);
  if (!claimCode) return [];
  const items = data[itemsKey];
  const list = Array.isArray(items) ? items : (items && items.toJS ? items.toJS() : []);
  return list
    .map((item) => mapHealthExpenseItem(item, claimCode))
    .filter(Boolean);
}

function mapToExpenses(data) {
  const tripInterruptedExpenses = mapToTripInterruptionExpense(data);
  const healthExpenseConfigs = [
    { itemsKey: 'tripInterruptionNonRefundPrepaidAirfareItems', lookupKey: 'nonRefundablePrepaidAirfare' },
    { itemsKey: 'tripInterruptionChangeFeesItems', lookupKey: 'changeFees' },
    { itemsKey: 'tripInterruptionAirfareReturnPointItems', lookupKey: 'airfareReturnDeparturePoint' },
    { itemsKey: 'tripInterruptionSeatUpgradeItems', lookupKey: 'medicallyNecessarySeatUpgrade' },
    { itemsKey: 'tripInterruptionTransportCatchUpItems', lookupKey: 'transportCatchUpDestination' },
    { itemsKey: 'tripInterruptionNonRefundTravelOtherItems', lookupKey: 'nonRefundablePrepaidTravelOther' },
    { itemsKey: 'tripInterruptionSingleSupplementItems', lookupKey: 'singleSupplement' },
    { itemsKey: 'tripInterruptionOutOfPocketItems', lookupKey: 'outOfPocketExpenses' },
    { itemsKey: 'tripInterruptionReturnOfRemainsItems', lookupKey: 'returnOfRemains' },
    { itemsKey: 'tripInterruptionBurialCremationItems', lookupKey: 'burialCremationPlaceOfDeath' },
    // Family member (same 4 selections: transport + 3 other)
    { itemsKey: 'tripInterruptionFamilyMemberNonRefundPrepaidAirfareItems', lookupKey: 'nonRefundablePrepaidAirfare' },
    { itemsKey: 'tripInterruptionFamilyMemberChangeFeesItems', lookupKey: 'changeFees' },
    { itemsKey: 'tripInterruptionFamilyMemberAirfareReturnPointItems', lookupKey: 'airfareReturnDeparturePoint' },
    { itemsKey: 'tripInterruptionFamilyMemberSeatUpgradeItems', lookupKey: 'medicallyNecessarySeatUpgrade' },
    { itemsKey: 'tripInterruptionFamilyMemberTransportCatchUpItems', lookupKey: 'transportCatchUpDestination' },
    { itemsKey: 'tripInterruptionFamilyMemberNonRefundTravelOtherItems', lookupKey: 'nonRefundablePrepaidTravelOther' },
    { itemsKey: 'tripInterruptionFamilyMemberSingleSupplementItems', lookupKey: 'singleSupplement' },
    { itemsKey: 'tripInterruptionFamilyMemberOutOfPocketItems', lookupKey: 'outOfPocketExpenses' },
    // Business partner / employer / key employee / caregiver / friend (same 4 selections)
    { itemsKey: 'tripInterruptionBusinessPartnerEtcNonRefundPrepaidAirfareItems', lookupKey: 'nonRefundablePrepaidAirfare' },
    { itemsKey: 'tripInterruptionBusinessPartnerEtcChangeFeesItems', lookupKey: 'changeFees' },
    { itemsKey: 'tripInterruptionBusinessPartnerEtcAirfareReturnPointItems', lookupKey: 'airfareReturnDeparturePoint' },
    { itemsKey: 'tripInterruptionBusinessPartnerEtcSeatUpgradeItems', lookupKey: 'medicallyNecessarySeatUpgrade' },
    { itemsKey: 'tripInterruptionBusinessPartnerEtcTransportCatchUpItems', lookupKey: 'transportCatchUpDestination' },
    { itemsKey: 'tripInterruptionBusinessPartnerEtcNonRefundTravelOtherItems', lookupKey: 'nonRefundablePrepaidTravelOther' },
    { itemsKey: 'tripInterruptionBusinessPartnerEtcSingleSupplementItems', lookupKey: 'singleSupplement' },
    { itemsKey: 'tripInterruptionBusinessPartnerEtcOutOfPocketItems', lookupKey: 'outOfPocketExpenses' },
    // Host at destination (same 4 selections)
    { itemsKey: 'tripInterruptionHostAtDestinationNonRefundPrepaidAirfareItems', lookupKey: 'nonRefundablePrepaidAirfare' },
    { itemsKey: 'tripInterruptionHostAtDestinationChangeFeesItems', lookupKey: 'changeFees' },
    { itemsKey: 'tripInterruptionHostAtDestinationAirfareReturnPointItems', lookupKey: 'airfareReturnDeparturePoint' },
    { itemsKey: 'tripInterruptionHostAtDestinationSeatUpgradeItems', lookupKey: 'medicallyNecessarySeatUpgrade' },
    { itemsKey: 'tripInterruptionHostAtDestinationTransportCatchUpItems', lookupKey: 'transportCatchUpDestination' },
    { itemsKey: 'tripInterruptionHostAtDestinationNonRefundTravelOtherItems', lookupKey: 'nonRefundablePrepaidTravelOther' },
    { itemsKey: 'tripInterruptionHostAtDestinationSingleSupplementItems', lookupKey: 'singleSupplement' },
    { itemsKey: 'tripInterruptionHostAtDestinationOutOfPocketItems', lookupKey: 'outOfPocketExpenses' },
    // Pregnancy / adoption (legal adoption) – transport sub-options
    { itemsKey: 'tripInterruptionPregnancyAdoptionNonRefundPrepaidAirfareItems', lookupKey: 'nonRefundablePrepaidAirfare' },
    { itemsKey: 'tripInterruptionPregnancyAdoptionChangeFeesItems', lookupKey: 'changeFees' },
    { itemsKey: 'tripInterruptionPregnancyAdoptionAirfareReturnPointItems', lookupKey: 'airfareReturnDeparturePoint' },
    { itemsKey: 'tripInterruptionPregnancyAdoptionSeatUpgradeItems', lookupKey: 'medicallyNecessarySeatUpgrade' },
    { itemsKey: 'tripInterruptionPregnancyAdoptionTransportCatchUpItems', lookupKey: 'transportCatchUpDestination' },
    { itemsKey: 'tripInterruptionPregnancyAdoptionNonRefundTravelOtherItems', lookupKey: 'nonRefundablePrepaidTravelOther' },
    { itemsKey: 'tripInterruptionPregnancyAdoptionSingleSupplementItems', lookupKey: 'singleSupplement' },
    { itemsKey: 'tripInterruptionPregnancyAdoptionOutOfPocketItems', lookupKey: 'outOfPocketExpenses' },
    // Employment / education – Job transfer
    { itemsKey: 'tripInterruptionEmploymentJobTransferNonRefundPrepaidAirfareItems', lookupKey: 'nonRefundablePrepaidAirfare' },
    { itemsKey: 'tripInterruptionEmploymentJobTransferChangeFeesItems', lookupKey: 'changeFees' },
    { itemsKey: 'tripInterruptionEmploymentJobTransferAirfareReturnPointItems', lookupKey: 'airfareReturnDeparturePoint' },
    { itemsKey: 'tripInterruptionEmploymentJobTransferSeatUpgradeItems', lookupKey: 'medicallyNecessarySeatUpgrade' },
    { itemsKey: 'tripInterruptionEmploymentJobTransferTransportCatchUpItems', lookupKey: 'transportCatchUpDestination' },
    { itemsKey: 'tripInterruptionEmploymentJobTransferNonRefundTravelOtherItems', lookupKey: 'nonRefundablePrepaidTravelOther' },
    { itemsKey: 'tripInterruptionEmploymentJobTransferSingleSupplementItems', lookupKey: 'singleSupplement' },
    { itemsKey: 'tripInterruptionEmploymentJobTransferOutOfPocketItems', lookupKey: 'outOfPocketExpenses' },
    // Employment / education – Involuntary loss of employment
    { itemsKey: 'tripInterruptionEmploymentInvoluntaryLossNonRefundPrepaidAirfareItems', lookupKey: 'nonRefundablePrepaidAirfare' },
    { itemsKey: 'tripInterruptionEmploymentInvoluntaryLossChangeFeesItems', lookupKey: 'changeFees' },
    { itemsKey: 'tripInterruptionEmploymentInvoluntaryLossAirfareReturnPointItems', lookupKey: 'airfareReturnDeparturePoint' },
    { itemsKey: 'tripInterruptionEmploymentInvoluntaryLossSeatUpgradeItems', lookupKey: 'medicallyNecessarySeatUpgrade' },
    { itemsKey: 'tripInterruptionEmploymentInvoluntaryLossTransportCatchUpItems', lookupKey: 'transportCatchUpDestination' },
    { itemsKey: 'tripInterruptionEmploymentInvoluntaryLossNonRefundTravelOtherItems', lookupKey: 'nonRefundablePrepaidTravelOther' },
    { itemsKey: 'tripInterruptionEmploymentInvoluntaryLossSingleSupplementItems', lookupKey: 'singleSupplement' },
    { itemsKey: 'tripInterruptionEmploymentInvoluntaryLossOutOfPocketItems', lookupKey: 'outOfPocketExpenses' },
    // Employment / education – Business meeting cancellation
    { itemsKey: 'tripInterruptionEmploymentBusinessMeetingNonRefundPrepaidAirfareItems', lookupKey: 'nonRefundablePrepaidAirfare' },
    { itemsKey: 'tripInterruptionEmploymentBusinessMeetingChangeFeesItems', lookupKey: 'changeFees' },
    { itemsKey: 'tripInterruptionEmploymentBusinessMeetingAirfareReturnPointItems', lookupKey: 'airfareReturnDeparturePoint' },
    { itemsKey: 'tripInterruptionEmploymentBusinessMeetingSeatUpgradeItems', lookupKey: 'medicallyNecessarySeatUpgrade' },
    { itemsKey: 'tripInterruptionEmploymentBusinessMeetingTransportCatchUpItems', lookupKey: 'transportCatchUpDestination' },
    { itemsKey: 'tripInterruptionEmploymentBusinessMeetingNonRefundTravelOtherItems', lookupKey: 'nonRefundablePrepaidTravelOther' },
    { itemsKey: 'tripInterruptionEmploymentBusinessMeetingSingleSupplementItems', lookupKey: 'singleSupplement' },
    { itemsKey: 'tripInterruptionEmploymentBusinessMeetingOutOfPocketItems', lookupKey: 'outOfPocketExpenses' },
    // Employment / education – Conference cancellation
    { itemsKey: 'tripInterruptionEmploymentConferenceNonRefundPrepaidAirfareItems', lookupKey: 'nonRefundablePrepaidAirfare' },
    { itemsKey: 'tripInterruptionEmploymentConferenceChangeFeesItems', lookupKey: 'changeFees' },
    { itemsKey: 'tripInterruptionEmploymentConferenceAirfareReturnPointItems', lookupKey: 'airfareReturnDeparturePoint' },
    { itemsKey: 'tripInterruptionEmploymentConferenceSeatUpgradeItems', lookupKey: 'medicallyNecessarySeatUpgrade' },
    { itemsKey: 'tripInterruptionEmploymentConferenceTransportCatchUpItems', lookupKey: 'transportCatchUpDestination' },
    { itemsKey: 'tripInterruptionEmploymentConferenceNonRefundTravelOtherItems', lookupKey: 'nonRefundablePrepaidTravelOther' },
    { itemsKey: 'tripInterruptionEmploymentConferenceSingleSupplementItems', lookupKey: 'singleSupplement' },
    { itemsKey: 'tripInterruptionEmploymentConferenceOutOfPocketItems', lookupKey: 'outOfPocketExpenses' },
    // Legal issues – Jury duty
    { itemsKey: 'tripInterruptionLegalIssuesJuryDutyNonRefundPrepaidAirfareItems', lookupKey: 'nonRefundablePrepaidAirfare' },
    { itemsKey: 'tripInterruptionLegalIssuesJuryDutyChangeFeesItems', lookupKey: 'changeFees' },
    { itemsKey: 'tripInterruptionLegalIssuesJuryDutyAirfareReturnPointItems', lookupKey: 'airfareReturnDeparturePoint' },
    { itemsKey: 'tripInterruptionLegalIssuesJuryDutySeatUpgradeItems', lookupKey: 'medicallyNecessarySeatUpgrade' },
    { itemsKey: 'tripInterruptionLegalIssuesJuryDutyTransportCatchUpItems', lookupKey: 'transportCatchUpDestination' },
    { itemsKey: 'tripInterruptionLegalIssuesJuryDutyNonRefundTravelOtherItems', lookupKey: 'nonRefundablePrepaidTravelOther' },
    { itemsKey: 'tripInterruptionLegalIssuesJuryDutySingleSupplementItems', lookupKey: 'singleSupplement' },
    { itemsKey: 'tripInterruptionLegalIssuesJuryDutyOutOfPocketItems', lookupKey: 'outOfPocketExpenses' },
    // Legal issues – Military service
    { itemsKey: 'tripInterruptionLegalIssuesMilitaryServiceNonRefundPrepaidAirfareItems', lookupKey: 'nonRefundablePrepaidAirfare' },
    { itemsKey: 'tripInterruptionLegalIssuesMilitaryServiceChangeFeesItems', lookupKey: 'changeFees' },
    { itemsKey: 'tripInterruptionLegalIssuesMilitaryServiceAirfareReturnPointItems', lookupKey: 'airfareReturnDeparturePoint' },
    { itemsKey: 'tripInterruptionLegalIssuesMilitaryServiceSeatUpgradeItems', lookupKey: 'medicallyNecessarySeatUpgrade' },
    { itemsKey: 'tripInterruptionLegalIssuesMilitaryServiceTransportCatchUpItems', lookupKey: 'transportCatchUpDestination' },
    { itemsKey: 'tripInterruptionLegalIssuesMilitaryServiceNonRefundTravelOtherItems', lookupKey: 'nonRefundablePrepaidTravelOther' },
    { itemsKey: 'tripInterruptionLegalIssuesMilitaryServiceSingleSupplementItems', lookupKey: 'singleSupplement' },
    { itemsKey: 'tripInterruptionLegalIssuesMilitaryServiceOutOfPocketItems', lookupKey: 'outOfPocketExpenses' },
    // Legal issues – Travel advisory
    { itemsKey: 'tripInterruptionLegalIssuesTravelAdvisoryNonRefundPrepaidAirfareItems', lookupKey: 'nonRefundablePrepaidAirfare' },
    { itemsKey: 'tripInterruptionLegalIssuesTravelAdvisoryChangeFeesItems', lookupKey: 'changeFees' },
    { itemsKey: 'tripInterruptionLegalIssuesTravelAdvisoryAirfareReturnPointItems', lookupKey: 'airfareReturnDeparturePoint' },
    { itemsKey: 'tripInterruptionLegalIssuesTravelAdvisorySeatUpgradeItems', lookupKey: 'medicallyNecessarySeatUpgrade' },
    { itemsKey: 'tripInterruptionLegalIssuesTravelAdvisoryTransportCatchUpItems', lookupKey: 'transportCatchUpDestination' },
    { itemsKey: 'tripInterruptionLegalIssuesTravelAdvisoryNonRefundTravelOtherItems', lookupKey: 'nonRefundablePrepaidTravelOther' },
    { itemsKey: 'tripInterruptionLegalIssuesTravelAdvisorySingleSupplementItems', lookupKey: 'singleSupplement' },
    { itemsKey: 'tripInterruptionLegalIssuesTravelAdvisoryOutOfPocketItems', lookupKey: 'outOfPocketExpenses' },
    // Cancellations / delays / carrier / weather – Missed connection
    { itemsKey: 'tripInterruptionCancellationsDelaysCarrierWeatherMissedConnectionNonRefundPrepaidAirfareItems', lookupKey: 'nonRefundablePrepaidAirfare' },
    { itemsKey: 'tripInterruptionCancellationsDelaysCarrierWeatherMissedConnectionChangeFeesItems', lookupKey: 'changeFees' },
    { itemsKey: 'tripInterruptionCancellationsDelaysCarrierWeatherMissedConnectionAirfareReturnPointItems', lookupKey: 'airfareReturnDeparturePoint' },
    { itemsKey: 'tripInterruptionCancellationsDelaysCarrierWeatherMissedConnectionSeatUpgradeItems', lookupKey: 'medicallyNecessarySeatUpgrade' },
    { itemsKey: 'tripInterruptionCancellationsDelaysCarrierWeatherMissedConnectionTransportCatchUpItems', lookupKey: 'transportCatchUpDestination' },
    { itemsKey: 'tripInterruptionCancellationsDelaysCarrierWeatherMissedConnectionNonRefundTravelOtherItems', lookupKey: 'nonRefundablePrepaidTravelOther' },
    { itemsKey: 'tripInterruptionCancellationsDelaysCarrierWeatherMissedConnectionSingleSupplementItems', lookupKey: 'singleSupplement' },
    { itemsKey: 'tripInterruptionCancellationsDelaysCarrierWeatherMissedConnectionOutOfPocketItems', lookupKey: 'outOfPocketExpenses' },
    // Cancellations / delays / carrier / weather – Four hours no connection
    { itemsKey: 'tripInterruptionCancellationsDelaysCarrierWeatherFourHoursNoConnectionNonRefundPrepaidAirfareItems', lookupKey: 'nonRefundablePrepaidAirfare' },
    { itemsKey: 'tripInterruptionCancellationsDelaysCarrierWeatherFourHoursNoConnectionChangeFeesItems', lookupKey: 'changeFees' },
    { itemsKey: 'tripInterruptionCancellationsDelaysCarrierWeatherFourHoursNoConnectionAirfareReturnPointItems', lookupKey: 'airfareReturnDeparturePoint' },
    { itemsKey: 'tripInterruptionCancellationsDelaysCarrierWeatherFourHoursNoConnectionSeatUpgradeItems', lookupKey: 'medicallyNecessarySeatUpgrade' },
    { itemsKey: 'tripInterruptionCancellationsDelaysCarrierWeatherFourHoursNoConnectionTransportCatchUpItems', lookupKey: 'transportCatchUpDestination' },
    { itemsKey: 'tripInterruptionCancellationsDelaysCarrierWeatherFourHoursNoConnectionNonRefundTravelOtherItems', lookupKey: 'nonRefundablePrepaidTravelOther' },
    { itemsKey: 'tripInterruptionCancellationsDelaysCarrierWeatherFourHoursNoConnectionSingleSupplementItems', lookupKey: 'singleSupplement' },
    { itemsKey: 'tripInterruptionCancellationsDelaysCarrierWeatherFourHoursNoConnectionOutOfPocketItems', lookupKey: 'outOfPocketExpenses' },
    // Cancellations / delays / carrier / weather – Cancellation of common carrier
    { itemsKey: 'tripInterruptionCancellationsDelaysCarrierWeatherCancellationOfCommonCarrierNonRefundPrepaidAirfareItems', lookupKey: 'nonRefundablePrepaidAirfare' },
    { itemsKey: 'tripInterruptionCancellationsDelaysCarrierWeatherCancellationOfCommonCarrierChangeFeesItems', lookupKey: 'changeFees' },
    { itemsKey: 'tripInterruptionCancellationsDelaysCarrierWeatherCancellationOfCommonCarrierAirfareReturnPointItems', lookupKey: 'airfareReturnDeparturePoint' },
    { itemsKey: 'tripInterruptionCancellationsDelaysCarrierWeatherCancellationOfCommonCarrierSeatUpgradeItems', lookupKey: 'medicallyNecessarySeatUpgrade' },
    { itemsKey: 'tripInterruptionCancellationsDelaysCarrierWeatherCancellationOfCommonCarrierTransportCatchUpItems', lookupKey: 'transportCatchUpDestination' },
    { itemsKey: 'tripInterruptionCancellationsDelaysCarrierWeatherCancellationOfCommonCarrierNonRefundTravelOtherItems', lookupKey: 'nonRefundablePrepaidTravelOther' },
    { itemsKey: 'tripInterruptionCancellationsDelaysCarrierWeatherCancellationOfCommonCarrierSingleSupplementItems', lookupKey: 'singleSupplement' },
    { itemsKey: 'tripInterruptionCancellationsDelaysCarrierWeatherCancellationOfCommonCarrierOutOfPocketItems', lookupKey: 'outOfPocketExpenses' },
    // Cancellations / delays / carrier / weather – Tour operator cancellation
    { itemsKey: 'tripInterruptionCancellationsDelaysCarrierWeatherTourOperatorCancellationNonRefundableUnusedTourCostItems', lookupKey: 'nonRefundableUnusedTourCost' },
    { itemsKey: 'tripInterruptionCancellationsDelaysCarrierWeatherTourOperatorCancellationReturnToDeparturePointItems', lookupKey: 'returnToDeparturePoint' },
    // Cancellations / delays / carrier / weather – Accident on way
    { itemsKey: 'tripInterruptionCancellationsDelaysCarrierWeatherAccidentOnWayNonRefundPrepaidAirfareItems', lookupKey: 'nonRefundablePrepaidAirfare' },
    { itemsKey: 'tripInterruptionCancellationsDelaysCarrierWeatherAccidentOnWayChangeFeesItems', lookupKey: 'changeFees' },
    { itemsKey: 'tripInterruptionCancellationsDelaysCarrierWeatherAccidentOnWayAirfareReturnPointItems', lookupKey: 'airfareReturnDeparturePoint' },
    { itemsKey: 'tripInterruptionCancellationsDelaysCarrierWeatherAccidentOnWaySeatUpgradeItems', lookupKey: 'medicallyNecessarySeatUpgrade' },
    { itemsKey: 'tripInterruptionCancellationsDelaysCarrierWeatherAccidentOnWayTransportCatchUpItems', lookupKey: 'transportCatchUpDestination' },
    { itemsKey: 'tripInterruptionCancellationsDelaysCarrierWeatherAccidentOnWayNonRefundTravelOtherItems', lookupKey: 'nonRefundablePrepaidTravelOther' },
    { itemsKey: 'tripInterruptionCancellationsDelaysCarrierWeatherAccidentOnWaySingleSupplementItems', lookupKey: 'singleSupplement' },
    { itemsKey: 'tripInterruptionCancellationsDelaysCarrierWeatherAccidentOnWayOutOfPocketItems', lookupKey: 'outOfPocketExpenses' },
    // Cancellations / delays / carrier / weather – Delay of private vehicle
    { itemsKey: 'tripInterruptionCancellationsDelaysCarrierWeatherDelayOfPrivateVehicleNonRefundPrepaidAirfareItems', lookupKey: 'nonRefundablePrepaidAirfare' },
    { itemsKey: 'tripInterruptionCancellationsDelaysCarrierWeatherDelayOfPrivateVehicleChangeFeesItems', lookupKey: 'changeFees' },
    { itemsKey: 'tripInterruptionCancellationsDelaysCarrierWeatherDelayOfPrivateVehicleAirfareReturnPointItems', lookupKey: 'airfareReturnDeparturePoint' },
    { itemsKey: 'tripInterruptionCancellationsDelaysCarrierWeatherDelayOfPrivateVehicleSeatUpgradeItems', lookupKey: 'medicallyNecessarySeatUpgrade' },
    { itemsKey: 'tripInterruptionCancellationsDelaysCarrierWeatherDelayOfPrivateVehicleTransportCatchUpItems', lookupKey: 'transportCatchUpDestination' },
    { itemsKey: 'tripInterruptionCancellationsDelaysCarrierWeatherDelayOfPrivateVehicleNonRefundTravelOtherItems', lookupKey: 'nonRefundablePrepaidTravelOther' },
    { itemsKey: 'tripInterruptionCancellationsDelaysCarrierWeatherDelayOfPrivateVehicleSingleSupplementItems', lookupKey: 'singleSupplement' },
    { itemsKey: 'tripInterruptionCancellationsDelaysCarrierWeatherDelayOfPrivateVehicleOutOfPocketItems', lookupKey: 'outOfPocketExpenses' },
    // Other reasons – Natural disaster
    { itemsKey: 'tripInterruptionOtherReasonsNaturalDisasterNonRefundPrepaidAirfareItems', lookupKey: 'nonRefundablePrepaidAirfare' },
    { itemsKey: 'tripInterruptionOtherReasonsNaturalDisasterChangeFeesItems', lookupKey: 'changeFees' },
    { itemsKey: 'tripInterruptionOtherReasonsNaturalDisasterAirfareReturnPointItems', lookupKey: 'airfareReturnDeparturePoint' },
    { itemsKey: 'tripInterruptionOtherReasonsNaturalDisasterSeatUpgradeItems', lookupKey: 'medicallyNecessarySeatUpgrade' },
    { itemsKey: 'tripInterruptionOtherReasonsNaturalDisasterTransportCatchUpItems', lookupKey: 'transportCatchUpDestination' },
    { itemsKey: 'tripInterruptionOtherReasonsNaturalDisasterNonRefundTravelOtherItems', lookupKey: 'nonRefundablePrepaidTravelOther' },
    { itemsKey: 'tripInterruptionOtherReasonsNaturalDisasterSingleSupplementItems', lookupKey: 'singleSupplement' },
    { itemsKey: 'tripInterruptionOtherReasonsNaturalDisasterOutOfPocketItems', lookupKey: 'outOfPocketExpenses' },
    // Other reasons – Unforeseeable event
    { itemsKey: 'tripInterruptionOtherReasonsUnforeseeableEventNonRefundPrepaidAirfareItems', lookupKey: 'nonRefundablePrepaidAirfare' },
    { itemsKey: 'tripInterruptionOtherReasonsUnforeseeableEventChangeFeesItems', lookupKey: 'changeFees' },
    { itemsKey: 'tripInterruptionOtherReasonsUnforeseeableEventAirfareReturnPointItems', lookupKey: 'airfareReturnDeparturePoint' },
    { itemsKey: 'tripInterruptionOtherReasonsUnforeseeableEventSeatUpgradeItems', lookupKey: 'medicallyNecessarySeatUpgrade' },
    { itemsKey: 'tripInterruptionOtherReasonsUnforeseeableEventTransportCatchUpItems', lookupKey: 'transportCatchUpDestination' },
    { itemsKey: 'tripInterruptionOtherReasonsUnforeseeableEventNonRefundTravelOtherItems', lookupKey: 'nonRefundablePrepaidTravelOther' },
    { itemsKey: 'tripInterruptionOtherReasonsUnforeseeableEventSingleSupplementItems', lookupKey: 'singleSupplement' },
    { itemsKey: 'tripInterruptionOtherReasonsUnforeseeableEventOutOfPocketItems', lookupKey: 'outOfPocketExpenses' },
  ];
  const healthExpenses = healthExpenseConfigs.reduce(
    (acc, { itemsKey, lookupKey }) => [...acc, ...mapHealthExpensesByType(data, itemsKey, lookupKey)],
    []
  );
  return [...tripInterruptedExpenses, ...healthExpenses];
}

function mapToTripInterruptionExpense(data) {
  if (data.travelInterruption !== 'true' || !data.lossInformationItems || data.lossInformationItems.length < 1) {
    return [];
  }
  const claimCode = stepTripInterruptionTugoLookup.tripInterruption.claimCode;
  const expenses = [];

  data.lossInformationItems.forEach(
    (item) => {
      const expense = mapInterruptionItemExpense(item, data, claimCode);
      if (!!expense) {
        expenses.push(expense);
      }
      const reimburseExpense = mapReimbursement(item, data, claimCode);
      if (!!reimburseExpense) {
        expenses.push(reimburseExpense);
      }
    }
  );

  return expenses;
}

function mapInterruptionItemExpense(item, formData, claimCode) {
  return mapExpenseItem(item, formData.dateTripInterrupted, claimCode);
}

function mapExpenseItem(item, itemDate, claimCode) {
  if (!item || !item.amountPaidLoss || !item.currentAmountPaidLoss) {
    return null;
  }
  return {
    shortDescription: `${item.companyNameLoss}`,
    dateOfExpense: item.dateOfLoss,
    clientCost: item.amountPaidLoss,
    currency: item.currentAmountPaidLoss,
    rate: null,
    requestedAmount: null,
    claimTypeCode: claimCode,
  };
}

function mapReimbursement(item, formData, claimCode) {
  if (!item || !item.howMuchReceivedReimbursement || !item.currentReceivedReimbursement || item.haveYouReceivedReimbursement !== 'true') {
    return null;
  }
  return {
    shortDescription: `${item.fromWhomReceivedReimbursement} (Reimbursement)`,
    dateOfExpense: item.dateReimbursementReceived,
    clientCost: `${item.howMuchReceivedReimbursement * -1}`,
    currency: item.currentReceivedReimbursement,
    rate: null,
    requestedAmount: null,
    claimTypeCode: claimCode,
  };
}

// Lookup key -> description for document sections (StepSupportingDocuments)
const LOOKUP_KEY_DESCRIPTIONS = {
  nonRefundablePrepaidAirfare: 'Non-refundable prepaid airfare',
  changeFees: 'Change fees',
  airfareReturnDeparturePoint: 'Airfare return to departure point',
  medicallyNecessarySeatUpgrade: 'Medically necessary seat upgrade',
  transportCatchUpDestination: 'Transport to catch up to destination',
  nonRefundablePrepaidTravelOther: 'Non-refundable prepaid travel (other)',
  singleSupplement: 'Single supplement',
  outOfPocketExpenses: 'Out of pocket expenses',
  returnOfRemains: 'Return of remains',
  burialCremationPlaceOfDeath: 'Burial or cremation at place of death',
  nonRefundableUnusedTourCost: 'Non-refundable unused tour cost',
  returnToDeparturePoint: 'Return to departure point',
  tripInterruption: 'Trip Interruption',
};

function mapClaimExpensesLevelItem(claimType, description, expenses) {
  return {
    claimCode: claimType.claimCode,
    description,
    claimTypeId: claimType.claimTypeId,
    requiredDocuments: claimType.requiredDocuments,
    order: null,
    expenses: expenses || [],
  };
}

/**
 * Maps Trip Interruption Tugo form data to claim-expense-level list for StepSupportingDocuments.
 * Returns list of { claimCode, description, claimTypeId, requiredDocuments, order, expenses }.
 */
function hasTripInterruptionTugoFormSelection(data) {
  if (!data) return false;
  const expenseTypes = data.expenseTypesClaiming;
  const typesArr = Array.isArray(expenseTypes) ? expenseTypes : (expenseTypes && typeof expenseTypes.toJS === 'function' ? expenseTypes.toJS() : []) || [];
  const hasHealth = typesArr.includes('health') && (
    data.healthClaimSelfOrCompanion || data.healthClaimFamilyMember ||
    data.healthClaimBusinessPartnerEtc || data.healthClaimHostAtDestination
  );
  const hasPregnancyAdoption = typesArr.includes('pregnancyAndAdoption') && data.pregnancyAdoptionClaimLegalAdoption;
  const hasEmploymentEducation = typesArr.includes('employmentAndEducation') && (
    data.employmentEducationClaimJobTransfer || data.employmentEducationClaimInvoluntaryLossEmployment ||
    data.employmentEducationClaimBusinessMeetingCancellation || data.employmentEducationClaimConferenceCancellation
  );
  const hasLegalIssues = typesArr.includes('legalIssues') && (
    data.legalIssuesClaimJuryDuty || data.legalIssuesClaimMilitaryService || data.legalIssuesClaimTravelAdvisory
  );
  return !!(hasHealth || hasPregnancyAdoption || hasEmploymentEducation || hasLegalIssues);
}

function mapToClaimExpensesLevel(data, claimTypes, selectedBenefits) {
  // Include TC codes so PL-STCAN-8 (TC-only policy with embedded TI form) passes the gate below.
  const claimCodeList = [
    ...(stepTripInterruptionTugoLookup.claimCodeList || []),
    ...(stepTripCancellationTugoLookup.claimCodeList || []),
    ...(stepTripCancellationTravellerTugoLookup.claimCodeList || []),
  ];
  const list = [];
  const selected = !!selectedBenefits && typeof selectedBenefits.toJS === 'function'
    ? selectedBenefits.toJS()
    : selectedBenefits || [];
  // Same logic for health and PREGNANCY_ADOPTION: when form has selection, allow docs even if selectedBenefits has no Tugo claim code
  const formHasSelection = hasTripInterruptionTugoFormSelection(data);
  if (selected.length > 0 && !selected.some((sel) => claimCodeList.includes(sel.claimCode)) && !formHasSelection) {
    return list;
  }
  if (!claimTypes || claimTypes.length === 0) {
    return list;
  }

  const allExpenses = mapToExpenses(data);
  if (allExpenses.length === 0) {
    return list;
  }

  // Group expenses by claimTypeCode
  const byClaimCode = new Map();
  allExpenses.forEach((exp) => {
    const code = exp.claimTypeCode;
    if (!code) return;
    if (!byClaimCode.has(code)) {
      byClaimCode.set(code, []);
    }
    byClaimCode.get(code).push(exp);
  });

  // Find description for each claim code (reverse lookup from expenseLookup)
  const healthExpenseConfigs = [
    { lookupKey: 'nonRefundablePrepaidAirfare' },
    { lookupKey: 'changeFees' },
    { lookupKey: 'airfareReturnDeparturePoint' },
    { lookupKey: 'medicallyNecessarySeatUpgrade' },
    { lookupKey: 'transportCatchUpDestination' },
    { lookupKey: 'nonRefundablePrepaidTravelOther' },
    { lookupKey: 'singleSupplement' },
    { lookupKey: 'outOfPocketExpenses' },
    { lookupKey: 'returnOfRemains' },
    { lookupKey: 'burialCremationPlaceOfDeath' },
  ];
  const claimCodeToDescription = new Map();
  healthExpenseConfigs.forEach(({ lookupKey }) => {
    const code = getClaimCodeFromLookup(lookupKey);
    if (code && LOOKUP_KEY_DESCRIPTIONS[lookupKey]) {
      claimCodeToDescription.set(code, LOOKUP_KEY_DESCRIPTIONS[lookupKey]);
    }
  });
  const mainTripInterruptionCode = stepTripInterruptionTugoLookup.tripInterruption && (stepTripInterruptionTugoLookup.tripInterruption.claimCode || (stepTripInterruptionTugoLookup.tripInterruption.associatedClaimCodes && stepTripInterruptionTugoLookup.tripInterruption.associatedClaimCodes[0]));
  if (mainTripInterruptionCode) {
    claimCodeToDescription.set(mainTripInterruptionCode, LOOKUP_KEY_DESCRIPTIONS.tripInterruption);
  }

  byClaimCode.forEach((expenses, documentClaimCode) => {
    const claimTypeItem = claimTypes.find((item) => item.claimCode === documentClaimCode);
    if (!claimTypeItem) return;
    const description = claimCodeToDescription.get(documentClaimCode) || claimTypeItem.description || documentClaimCode;
    const benefit = mapClaimExpensesLevelItem(claimTypeItem, description, expenses);
    benefit.claimCode = documentClaimCode;
    list.push(benefit);
  });

  return list;
}

export default {
  mapToParentSection,
  mapToQuestionnaire,
  mapToExpenses,
  mapToClaimExpensesLevel,
};



// WEBPACK FOOTER //
// ./app/containers/FastCover/dataMapper/stepTripInterruptionTugoDataMapper.js